const theme = require('./themes/mach3.json')

module.exports = {
  title: 'Nom du challenge',
  subTitle: 'explication du challenge',
  formLink: 'https://goo.gl/forms/u00WBxeK1kQco0uQ2',
  maxAmountEvents: 2,
  limitMonthInTheFuture: 2,
  theme,
}
